import { PayloadAction } from '@reduxjs/toolkit';
import { put, takeLatest } from 'redux-saga/effects';
import {
  fetchPaymentList,
  fetchPaymentListFailure,
  fetchPaymentListSuccess,
} from 'redux/slice/allocation/PaymentList.slice';
import {
  IPaymentListResponse,
  PaymentListPayload,
} from 'redux/types/AllocationPayment.types';
import { allocationEndpoints } from 'services/api/endPoints';
import { HTTPClient } from 'services/api/http-client';

function* fetchPaymentListSaga({ payload }: PayloadAction<PaymentListPayload>) {
  try {
    const { allocationId, data, page, pageSize } = payload;
    // const allocationId = allocationId;
    // Make the API call to get the allocation details
    const response: IPaymentListResponse = yield HTTPClient.GetRequest(
      allocationEndpoints.GET_PAYMENT_LIST(allocationId, page, pageSize),
      data
    );

    // Assuming the response is a JSON object containing a list
    const paymentListData = response;
    // Dispatch success action with the received data
    yield put(fetchPaymentListSuccess(paymentListData));
  } catch (error) {
    // Dispatch failure action if there's an error
    yield put(
      fetchPaymentListFailure({
        error: { message: 'Failed to fetch allocation list' },
      })
    );
  }
}

export function* watchPaymentFileSagas() {
  yield takeLatest(fetchPaymentList.type, fetchPaymentListSaga);
}
